import React from "react";
import { OptimizedImageUrls } from "../../../component-configuration/optimized-image";
import { PreviewKind, TopLevelMediaKind } from "@radivision/graphql";
import { ImageHelper } from "../../../utilities/image-helper";
import exportsLogo from "../../../../static/experts_black.png";
import membersBackground from "../images/membersBackground.jpg";
import BulletPoints from "./bullet-points";

const Members = () => {
  const item = {
    previews: {
      count: 1,
      edges: [
        {
          cursor: "0",
          preview: {
            mediaAsset: {
              id: "9M_-S-urRYGbjzBwTc36xw",
              files: [
                {
                  id: "qTrCvHcMShC08-0f0xSTXQ",
                  name: "xMl04JSiRcmHjJUKfIE9cA.png",
                  heightInPixels: null,
                  widthInPixels: null,
                  path: "xm/l0",
                  status: null,
                },
              ],
              state: null,
              topLevelMediaType: {
                kind: "IMAGE",
              },
            },
            kind: "LOGO",
            link: null,
          },
        },
      ],
    },
  };
  // const logo: OptimizedImageUrls = ImageHelper.fetchOptimizedImageUrl({
  //   imageType: "PREVIEW",
  //   preview: {
  //     content: item.previews,
  //     previewKind: PreviewKind.LOGO,
  //     topLevelMedia: TopLevelMediaKind.IMAGE,
  //   },
  //   desiredDimensions: { containerWidthRatio: 3 / 4, numberOfItems: 1 },
  //   isSquareImage: false,
  // });
  return (
    <div className="members-banner" style={{ backgroundImage: `url(${membersBackground})` }}>
      {/* <div className="members-banner-shade" /> */}

      <h3>Who is on Radivision?</h3>
      <div className="my-4 members">
        <div className="circle">
          <p>Founders</p>
        </div>
        <div className="circle">
          <p style={{ display: "flex", flexDirection: "column" }}>Investors</p>
        </div>
        {/* <div className="circle experts">
          <img src={exportsLogo} />
        </div> */}
        <div className="circle">
          <p>Community Members</p>
        </div>
        <div className="circle">
          <p>Ecosystem Partners</p>
        </div>
      </div>
      <BulletPoints />
    </div>
  );
};

export default Members;
